export default function EquipmentDetailImageEditModalController(
  $scope,
  $uibModalInstance,
  image,
  MediaService,
  gettextCatalog
) {
  'ngInject';

  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.image = {};
  $scope.description = null;

  const onLoad = () => {
    $scope.image = image;

    $scope.description = image.description || '';
  };

  onLoad();

  $scope.save = function () {

    $scope.loading = true;
    $scope.errorFlag = false;

    $scope.image.attributes = {
      ...$scope.image.attributes,
      description: $scope.description,
    };

    MediaService.updateImage($scope.image)
      .then(function() {
        $scope.loading = false;
        $uibModalInstance.close($scope.image); //pass back image to update the included model
      })
      .catch(function(error) {
        let errorMsg = gettextCatalog.getString('An error occurred while editing the image. Please try again later.');
        if (error) {
          if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else if (!!error.status && !!error.statusText) {
            errorMsg =
              gettextCatalog.getString('An error occurred while editing the image: ') +
              (error.status.toString() + ' - ' + error.statusText.toString());
          }
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.loading = false;
      });
  };

  $scope.cancel = function() {
    $uibModalInstance.close();
  };
}
